import { TypographyVariantsOptions } from "@mui/material/styles";

export const typography: TypographyVariantsOptions = {
  fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
  fontSize: 14,
  htmlFontSize: 16,
  h1: {
    fontSize: "6rem",
    fontWeight: 300,
    lineHeight: 1.167,
    letterSpacing: "-0.01562em",
  },
};
